(() => {
  const selector = '.product-media-modal';

  const setLock = () => {
    const modal = document.querySelector(selector);
    const isOpen = modal && modal.hasAttribute('open');
    document.body.classList.toggle('sanoire-lightbox-open', !!isOpen);
  };

  // Run now
  setLock();

  // Watch for open attribute changes
  const obs = new MutationObserver(setLock);
  const modal = document.querySelector(selector);
  if (modal) obs.observe(modal, { attributes: true, attributeFilter: ['open'] });

  // Fallback: update on clicks (some themes toggle quickly)
  document.addEventListener('click', (e) => {
    if (e.target.closest(selector) || e.target.closest('[data-media-id]')) {
      setTimeout(setLock, 0);
    }
  });
})();


(() => {
  const MODAL_SELECTOR = '.product-media-modal';
  const INNER_SELECTOR = '.sanoire-lightbox__inner';
  const SLIDE_SELECTOR = '.sanoire-lightbox__slide';
  const THUMB_SELECTOR = '.sanoire-lightbox__thumb';

  // If your arrows are swapped visually/behaviorally, set this to true:
  // true  => clicking "next" goes previous, and "prev" goes next
  const SWAP_ARROW_BUTTONS = true;

  // Swipe settings
  const SWIPE_THRESHOLD_PX = 35;  // how far to swipe before changing
  const SWIPE_MAX_Y_PX = 60;      // ignore if user is mostly scrolling vertically

  function getOpenModal() {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return null;
    return modal.hasAttribute('open') ? modal : null;
  }

  function getLightboxRoot() {
    const modal = getOpenModal();
    if (!modal) return null;
    return modal.querySelector(INNER_SELECTOR);
  }

  function getSlides(root) {
    return Array.from(root.querySelectorAll(SLIDE_SELECTOR));
  }

  function getThumbs(root) {
    return Array.from(root.querySelectorAll(THUMB_SELECTOR));
  }

  function getActiveIndex(slides) {
    const idx = slides.findIndex(s => s.classList.contains('is-active'));
    return idx >= 0 ? idx : 0;
  }

  function setActive(root, newIndex) {
    const slides = getSlides(root);
    if (!slides.length) return;

    const thumbs = getThumbs(root);
    const oldIndex = getActiveIndex(slides);

    // clamp/wrap
    newIndex = (newIndex + slides.length) % slides.length;

    slides[oldIndex]?.classList.remove('is-active');
    slides[newIndex]?.classList.add('is-active');

    if (thumbs.length) {
      thumbs[oldIndex]?.classList.remove('is-active');
      thumbs[newIndex]?.classList.add('is-active');
      thumbs[newIndex]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  function goNext(root) {
    const slides = getSlides(root);
    const idx = getActiveIndex(slides);
    setActive(root, idx + 1);
  }

  function goPrev(root) {
    const slides = getSlides(root);
    const idx = getActiveIndex(slides);
    setActive(root, idx - 1);
  }

  // --- 1) Button clicks (with optional swap) ---
  document.addEventListener('click', (e) => {
    const root = getLightboxRoot();
    if (!root) return;

    const prevBtn = e.target.closest('.sanoire-lightbox__arrow--prev');
    const nextBtn = e.target.closest('.sanoire-lightbox__arrow--next');
    if (!prevBtn && !nextBtn) return;

    e.preventDefault();

    if (SWAP_ARROW_BUTTONS) {
      // swapped
      if (nextBtn) goPrev(root);
      if (prevBtn) goNext(root);
    } else {
      // normal
      if (nextBtn) goNext(root);
      if (prevBtn) goPrev(root);
    }
  });

  // --- 2) Keyboard arrows (← →) ---
  document.addEventListener('keydown', (e) => {
    const root = getLightboxRoot();
    if (!root) return;

    // Don’t hijack if user is typing in an input
    const tag = (document.activeElement && document.activeElement.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || document.activeElement?.isContentEditable) return;

    if (e.key === 'ArrowRight') {
      e.preventDefault();
      goNext(root);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      goPrev(root);
    }
  });

  // --- 3) Mobile swipe on the stage ---
  function attachSwipe(root) {
    const stage = root.querySelector('.sanoire-lightbox__stage');
    if (!stage) return;

    let startX = 0;
    let startY = 0;
    let tracking = false;

    stage.addEventListener('touchstart', (e) => {
      if (!getOpenModal()) return;
      if (e.touches.length !== 1) return;

      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      tracking = true;
    }, { passive: true });

    stage.addEventListener('touchmove', (e) => {
      if (!tracking) return;
      if (e.touches.length !== 1) return;

      const t = e.touches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      // If the user is mostly scrolling vertically, ignore swipe navigation
      if (Math.abs(dy) > SWIPE_MAX_Y_PX && Math.abs(dy) > Math.abs(dx)) {
        tracking = false;
      }
    }, { passive: true });

    stage.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;

      const changed = e.changedTouches && e.changedTouches[0];
      if (!changed) return;

      const dx = changed.clientX - startX;
      const dy = changed.clientY - startY;

      if (Math.abs(dy) > SWIPE_MAX_Y_PX) return;
      if (Math.abs(dx) < SWIPE_THRESHOLD_PX) return;

      // swipe left => next, swipe right => prev
      if (dx < 0) goNext(root);
      else goPrev(root);
    }, { passive: true });
  }

  // Attach swipe whenever modal opens (or if already open)
  function initWhenReady() {
    const root = getLightboxRoot();
    if (!root) return;
    if (root.dataset.sanoireSwipeInit === '1') return;
    root.dataset.sanoireSwipeInit = '1';
    attachSwipe(root);

    // Ensure there is an active slide on open
    const slides = getSlides(root);
    if (slides.length && !slides.some(s => s.classList.contains('is-active'))) {
      slides[0].classList.add('is-active');
      const thumbs = getThumbs(root);
      thumbs[0]?.classList.add('is-active');
    }
  }

  // Watch for the modal opening
  const modal = document.querySelector(MODAL_SELECTOR);
  if (modal) {
    const obs = new MutationObserver(() => {
      if (modal.hasAttribute('open')) initWhenReady();
    });
    obs.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  // Also try once on load
  document.addEventListener('DOMContentLoaded', initWhenReady);
})();
